// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__2RU9o","title":"card_title__2i0Z2","inActive":"card_inActive__28MAI"};